export const WEALTH_SAVINGS_PAGE_SLUG = 'wealth-savings';
